import React, { useState, useEffect } from "react";
import {
  Box,
  Slide,
  Stack,
  FormControl,
  OutlinedInput,
  Typography,
  Button,
  Select,
  MenuItem,
  Switch,
  LinearProgress,
  Checkbox,
} from "@mui/material";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import { useHistory } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import InfoIcon from "@mui/icons-material/Info";
import LibraryMusicOutlinedIcon from "@mui/icons-material/LibraryMusicOutlined";
import PageHeader from "../../components/PageHeader";
import { Upload, Calendar, Plus, Lock } from "react-iconly";
import { Formik } from "formik";
import * as yup from "yup";
import "./index.scss";
import SikiInput from "../../components/SikiInput";
import DropDown from "../../components/DropDown";
import IosSwitch from "../../components/IOSSwitch";
import { Images } from "./../../assets/common";
import ApiService from "../../services/api-service";
import ConfirmNftPopup from "./../../components/ConfirmNftPopup";
import { useDispatch } from "react-redux";
import GroupsIcon from "@mui/icons-material/Groups";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { parseBlob } from "music-metadata";
import { compressCoverImage } from "../../utils/imageCompression";
import { handleThumbnailChange as handleThumbnailChangeExternal } from './handlers'

import {
  getErrorString,
  validateForm,
  isEmpty,
  checkImgExtension,
  checkExtension,
  disableDates,
  checkContributers,
} from "../../constants/function";
import Notifier from "../../components/Notifier";
import notifier from "../../components/Notifier";
import SuccessPopup from "../../components/SuccessPopup";
import Loader from "../../components/Loader";
import ErrorMsg from "./../../components/Error";
import { getBalance } from "../../asyncAction/asyncBalance";

import ErrorPopup from "../../components/ErrorPopup";
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { useTranslation } from "react-i18next";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
/**
 * The studio's song upload form. On its own route it goes to the Library when
 * done; pass `onUploaded` to embed it (e.g. in the song-request dialog) and get
 * `{ _id, title, releaseDate }` of the new song instead.
 */
export default function UploadMusic({ onUploaded } = {}) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [openNftPopup, setNftPopup] = useState(false);
  const [error, setError] = useState(false);
  const [Errors, setErrors] = useState({});
  const [sum, setSum] = useState(0);
  const [OR, setOR] = useState(0);
  const [musicId, setMusicId] = useState(null);
  const [open, setOpen] = useState(false);
  const [genres, setGenres] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [audio, setAudio] = React.useState("");
  const [isPrivate, setPrivate] = React.useState(false);
  const [thumbnailImg, setThumbnailImg] = useState();
  const [success, setSuccess] = useState(false);
  const [contributers, setContributers] = useState([" "]);
  const [formdata, setFormData] = useState(null);
  // const [file, setFile] = useState();
  const [gif, setGif] = useState();
  const { userData } = useContext(UserContext);
  const [royalties, setRoyalties] = useState([{}]);
  const [royalty, setRoyalty] = useState([]);
  const [value, setValue] = useState("no");
  const [artist, setArtist] = useState([" "]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [uploadLimits, setUploadLimits] = useState(null);

  useEffect(() => {
    const fetchUploadLimits = async () => {
      try {
        const response = await ApiService.GET_UPLOAD_LIMITS();
        setUploadLimits(response?.result || null);
      } catch (error) {
        console.error("Failed to fetch upload limits:", error);
      }
    };
    fetchUploadLimits();
  }, []);

  // Error styling helper
  const getErrorStyle = (hasError) => hasError ? {
    border: '1px solid rgba(255, 107, 107, 0.5)',
    borderRadius: '8px',
    boxShadow: '0 0 0 3px rgba(255, 107, 107, 0.1)',
    transition: 'all 0.2s ease-in-out'
  } : {};

  // Auto-populate current user as main artist and 100% royalty on mount
  useEffect(() => {
    if (userData && artist[0] === " ") {
      // Extract profileImg as string - handle both object and string formats
      const profileImgUrl = typeof userData.profileImg === 'object' && userData.profileImg?.filePath
        ? userData.profileImg.filePath
        : userData.profileImg;

      const userArtist = {
        role: "",
        uId: userData._id,
        name: userData.displayArtistName || `${userData.firstName} ${userData.lastName}`,
        profileImg: profileImgUrl,
        firstName: userData.firstName,
        fullName: `${userData.firstName} ${userData.lastName}`,
        lastName: userData.lastName,
        displayArtistName: userData.displayArtistName || `${userData.firstName} ${userData.lastName}`,
      };

      setArtist([userArtist]);

      // Set role to mainArtist by default
      const role = [...roless];
      role[0] = {
        role: "mainArtist",
        title: t("dropDown.text9"),
        id: userData._id,
        name: userData.displayArtistName || `${userData.firstName} ${userData.lastName}`,
      };
      setRoless(role);

      // Auto-populate uploader with 100% royalty
      const userDisplayName = userData.displayArtistName || `${userData.firstName} ${userData.lastName}`;
      setRoyalties([{ _id: userData._id, percentage: 100 }]);
      setRoyalty([userDisplayName]);

      // Set sum to 100 since we just auto-populated 100%
      setSum(100);
    }
  }, [userData]);
  const schema = yup.object().shape({
    title: yup.string(),
    releaseDate: yup.string(),
    description: yup.string(),
    artist: yup.string(),
    ownerRoyalty: yup.string(),
    genre: yup.string(),
    subGenre: yup.string(),
    audioFile: yup.mixed(),
    ISRCCode: yup.mixed(),
    thumbnailImg: yup.mixed(),
    GIF: yup.mixed(),
    isExplicit: yup.boolean(),
    isAIGenerated: yup.boolean(),
    subscribersOnly: yup.boolean(),
    lyrics: yup.string(),
    rightsConfirmed: yup.boolean().oneOf([true], "You must confirm rights ownership"),
  });

  //validate fields for upload music

  const uploadMusic = async (values, errors) => {
    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }

    if (!values.rightsConfirmed) {
      notifier.error("You must confirm rights ownership before uploading.");
      return;
    }

    // Pre-check upload limits
    if (uploadLimits && uploadLimits.remaining !== -1 && uploadLimits.remaining <= 0) {
      notifier.error(
        uploadLimits.tier === "free"
          ? "You have reached your free upload limit of 3 songs. Subscribe to upload unlimited songs."
          : `You've reached your monthly upload limit of ${uploadLimits.limit} songs. Upgrade to Pro for unlimited uploads!`
      );
      return;
    }

    sumRoyalties();

    // Skip the NFT popup and upload directly (no upfront cost now)
    await createNft(true, "siki", 1, "Hedera", values);
  };

  const createNft = async (isNft, currency, units, platform, formValues = null) => {
    if (isNft) {
      const values = formValues || formdata;

      try {
        // Validate only required fields for submission
        const submissionErrors = {};

        // Required fields from all steps
        if (!values.audioFile) submissionErrors.audioFile = "";
        if (!values.thumbnailImg) submissionErrors.thumbnailImg = "";
        if (!values.title || values.title.trim() === "") submissionErrors.title = "";
        if (!roless || roless.length === 0 || !roless[0].role || roless[0].role === "") submissionErrors.artist = "";
        if (!artist || artist.length === 0 || artist[0] === " " || !artist[0].uId) submissionErrors.artist = "";
        if (!values.description || values.description.trim() === "") submissionErrors.description = "";
        if (!values.genre || values.genre === "") submissionErrors.genre = "";
        if (!values.subGenre || values.subGenre === "") submissionErrors.subGenre = "";
        if (values.isExplicit === "") submissionErrors.isExplicit = "";
        if (!values.releaseDate || values.releaseDate === "") submissionErrors.releaseDate = "";

        // Royalty validation (only if user chose "yes" for sharing)
        if (value === "yes" && !values.ownerRoyalty) submissionErrors.ownerRoyalty = "";
        if (value !== "no" && isEmpty(royalties[0])) submissionErrors.royalties = "";

        if (Object.keys(submissionErrors).length > 0) {
          setErrors(submissionErrors);
          setError(true);
          notifier.error("Please fill in all required fields");
          return;
        }
        const formData = new FormData();
        formData.append("file", values.audioFile, values.audioFile.name);
        // if (values.GIF) formData.append("GIF", values.GIF, values.GIF.name);
        if (
          (sum === 100 && !isEmpty(royalties[0])) ||
          (value === "no" && sum === 100)
        ) {
          const v = values;
          isEmpty(royalties[0])
            ? delete v["royalties"]
            : formData.append("royalties", JSON.stringify(royalties));
        } else {
          notifier.error(t("notifier.error.toast1"));
          return;
        }
        formData.append("description", values.description);

        if (artist.length && roless.length) {
          const artistData = [];
          for (let index = 0; index < artist.length; index++) {
            // console.log("rrrrr", roless[index]["role"]);
            if (roless[index]["role"] !== "" && artist[index].uId) {
              // Extract profileImg as string - handle both object and string formats
              const profileImgUrl = typeof artist[index].profileImg === 'object' && artist[index].profileImg?.filePath
                ? artist[index].profileImg.filePath
                : artist[index].profileImg;

              artistData.push({
                role: roless[index]["role"],
                ...artist[index],
                profileImg: profileImgUrl,
              });
            }
          }
          // console.log(
          //   "::artistData::",
          //   artistData,
          //   artistData.length,
          //   artistData.role,
          //   artist.length
          // );
          if (roless.length && roless.length > 0) {
            // console.log("roless.length", roless.length);
            formData.append("artistData", JSON.stringify(artistData));
          } else {
            delete values["artistData"];
          }
        }
        // formData.append("artist", values.artist);
        //  formData.append("ownerRoyalty", values.ownerRoyalty);
        const ext = checkExtension(values.thumbnailImg.name);
        formData.append(
          "thumbnailImg",
          values.thumbnailImg,
          `${new Date().getTime()}.${ext}`
        );
        formData.append("title", values.title);
        formData.append("genre", values.genre);
        formData.append("subGenre", values.subGenre);
        formData.append("isExplicit", values.isExplicit);
        formData.append("isAIGenerated", values.isAIGenerated);
        formData.append("subscribersOnly", values.subscribersOnly ? "true" : "false");
        if (values.lyrics && values.lyrics.trim()) formData.append("lyrics", values.lyrics.trim());
        formData.append("ISRCCode", values.ISRCCode);
        formData.append("releaseDate", values.releaseDate);
        if (contributers.length && roles.length) {
          const collaborators = [];
          for (let index = 0; index < contributers.length; index++) {
            if (contributers[index]["id"]) {
              collaborators.push({
                _id: contributers[index]["id"],
                role: roles[index]["role"],
              });
            }
          }
          formData.append("collaborators", JSON.stringify(collaborators));
        }
        formData.append("private", false);

        // upload(formData);

        formData.append("currency", currency);
        formData.append("count", parseInt(units));
        formData.append("platform", platform);
        
        // Set loading and submitting states
        // The popup is already closed by the handleClose callback
        setLoading(true);
        setIsSubmitting(true);
        setUploadProgress(0);
        setUploadStatus("Preparing upload...");

        try {
          // Track real upload progress
          const res = await ApiService.CREATE_MUSIC_NFT_V5(formData, (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);

            if (percentCompleted < 30) {
              setUploadStatus("Uploading music file...");
            } else if (percentCompleted < 70) {
              setUploadStatus("Uploading metadata...");
            } else if (percentCompleted < 95) {
              setUploadStatus("Processing...");
            } else {
              setUploadStatus("Finalizing...");
            }
          });

          setUploadProgress(100);
          setUploadStatus("Complete!");

          dispatch(getBalance());

          // Small delay to show completion
          await new Promise(resolve => setTimeout(resolve, 500));

          notifier.success(t("notifier.success.toast2"));
          if (onUploaded) {
            onUploaded({
              _id: res?.result?._id,
              title: res?.result?.title || values.title,
              releaseDate: values.releaseDate,
            });
          } else {
            history.push("/app/Library");
          }
        } finally {
          setLoading(false);
          setIsSubmitting(false);
          setUploadProgress(0);
          setUploadStatus("");
        }
      } catch (error) {
        setLoading(false);
        setIsSubmitting(false);
        setUploadProgress(0);
        setUploadStatus("");
        // Don't need to close popup here as it's already closed
        // history.push("/app/MyMusic");
        notifier.error(getErrorString(error));
      }
    } else {
      setNftPopup(false);
      history.push("/app/MyMusic");
    }
  };
  function onFileChooser(id) {
    document.getElementById(id).click();
  }


  const getGeners = async () => {
    try {
      const response = await ApiService.GENRE_LIST();
      setGenres([...response["result"]]);
    } catch (error) {}
  };
  useEffect(() => {
    getGeners();
  }, []);
  useEffect(() => {}, [genres]);
  const [roles, setRoles] = useState([{ role: "", id: "", name: "" }]);
  const handleAddContributers = (type, index) => {
    switch (type) {
      case "add":
        setRoles(prev => [...prev, { role: "", id: "", name: "" }]);
        setContributers(prev => [...prev, " "]);
        break;
      case "remove":
        setRoles(prev => prev.filter((_, i) => i !== index));
        setContributers(prev => prev.filter((_, i) => i !== index));
        break;
      default:
        break;
    }
  };
  const setSelectedContributers = (val, id, i) => {
    const contri = contributers;
    const role = roles;
    contri[i] = { role: "", id: id, name: val };
    if (role.length && role[i]["role"]) {
      contri[i]["role"] = role[i]["role"];
    }
    setContributers([...contri]);
  };

  const handleRoleChange = (val, id, i) => {
    const role = roles;
    role[i] = {
      role: val,
      id: role["id"] ? role["id"] : "",
      name: role["role"] ? role["role"] : "",
    };
    const contri = contributers;
    if (contri[i]["id"]) {
      role[i] = {
        role: val,
        id: contri[i]["id"] ? contri[i]["id"] : "",
        name: contri[i]["name"] ? contri[i]["name"] : "",
      };
    }
    setRoles([...role]);
  };

  const [roless, setRoless] = useState([{ role: "", id: "", name: "" }]);
  const handleAddArtists = (type, index) => {
    const art = artist;
    const role = [...roless];
    switch (type) {
      case "add":
        role.push({ role: "", id: "", name: "" });
        setRoless(role);
        art.push(" ");
        setArtist([...art]);
        break;
      case "remove":
        role.splice(index, 1);

        setRoless([...role]);
        art.splice(index, 1);
        setArtist([...art]);

        break;
      default:
        break;
    }
  };
  const setSelectedArtist = (
    val,
    uId,
    profileImg,
    firstName,
    fullName,
    lastName,
    displayArtistName,
    i
  ) => {
    const art = artist;
    const role = roless;

    art[i] = {
      role: "",
      uId: uId,
      name: val,
      profileImg: profileImg,
      firstName: firstName,
      fullName: fullName,
      lastName: lastName,
      displayArtistName: val,
    };
    if (role.length && role[i]["role"]) {
      art[i]["role"] = role[i]["role"];
    }
    setArtist([...art]);
  };

  const handleArtistRoleChange = (val, title, id, i) => {
    const updated = roless.map((r, idx) => {
      if (idx !== i) return r;
      const art = artist[i];
      if (art?.["id"]) {
        return { role: val, title, id: art["id"], name: art["name"] || "" };
      }
      return { role: val, title, id: r["id"] || "", name: r["name"] || "" };
    });
    setRoless(updated);
  };

  const addMoreRoyalties = () => {
    const r = royalties;
    r.push({ _id: "", percentage: "" });
    setRoyalties([...r]);
  };
  const handleRemoveRoyalties = (index) => {
    const r = royalties;
    r.splice(index, 1);
    setRoyalties([...r]);
    const name = royalty;
    name.splice(index, 1);
    setRoyalty([...name]);
  };

  const sumRoyalties = (e) => {
    let s = 0;
    if (value === "yes") s = 0 + OR;
    royalties.forEach((r, index) => {
      if (r["percentage"] && r["percentage"] > 0) {
        s += r["percentage"];
      }
    });
    setSum(s);
  };

  // Validate required fields for each step
  const validateStep = (stepNumber, values) => {
    const errors = {};

    switch (stepNumber) {
      case 1:
        // Step 1: Audio file, thumbnail, artist with role, and title are required
        if (!values.audioFile) {
          errors.audioFile = true;
          notifier.error("Please upload an audio file");
        }
        if (!values.thumbnailImg) {
          errors.thumbnailImg = true;
          notifier.error("Please upload a cover image");
        }
        if (!values.title || values.title.trim() === "") {
          errors.title = true;
          notifier.error("Please enter a title");
        }
        // Check if at least one artist has a role
        if (!roless || roless.length === 0 || !roless[0].role || roless[0].role === "") {
          errors.artistRole = true;
          notifier.error("Please select an artist role");
        }
        // Check if artist is selected
        if (!artist || artist.length === 0 || artist[0] === " " || !artist[0].uId) {
          errors.artist = true;
          notifier.error("Please select an artist");
        }
        break;

      case 2:
        // Step 2: Description, genre, subGenre, explicit flag, and release date are required
        if (!values.description || values.description.trim() === "") {
          errors.description = true;
          notifier.error("Please enter a description");
        }
        if (!values.genre || values.genre === "") {
          errors.genre = true;
          notifier.error("Please select a genre");
        }
        if (!values.subGenre || values.subGenre === "") {
          errors.subGenre = true;
          notifier.error("Please select a sub-genre");
        }
        if (values.isExplicit === "") {
          errors.isExplicit = true;
          notifier.error("Please select if the content is explicit");
        }
        if (!values.releaseDate || values.releaseDate === "") {
          errors.releaseDate = true;
          notifier.error("Please select a release date");
        }
        break;

      case 3:
        // Step 3: Collaborators are optional, so always valid
        break;

      default:
        break;
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChangeValue = (event) => {
    setValue(event.target.value);
  };

  // Extract metadata from audio file and auto-populate fields
  const extractMetadataAndPopulate = async (file, setFieldValue) => {
    try {
      console.log('[UploadMusic] Extracting metadata from file:', file.name);

      const metadata = await parseBlob(file);

      if (metadata.common) {
        // Auto-populate title if not set
        if (metadata.common.title) {
          setFieldValue("title", metadata.common.title);
          console.log('[UploadMusic] Auto-populated title:', metadata.common.title);
        } else {
          // Fallback to filename without extension
          const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
          setFieldValue("title", fileNameWithoutExt);
          console.log('[UploadMusic] Auto-populated title from filename:', fileNameWithoutExt);
        }

        // Auto-populate genre if available
        if (metadata.common.genre) {
          const metadataGenre = Array.isArray(metadata.common.genre)
            ? metadata.common.genre[0]
            : metadata.common.genre;
          setFieldValue("genre", metadataGenre);
          console.log('[UploadMusic] Auto-populated genre:', metadataGenre);
        }

        // Auto-populate album artwork if available
        if (metadata.common.picture && metadata.common.picture.length > 0) {
          const picture = metadata.common.picture[0];
          const blob = new Blob([picture.data], { type: picture.format });
          const artworkFile = new File([blob], `artwork.${picture.format.split('/')[1] || 'jpg'}`, { type: picture.format });
          try {
            const compressed = await compressCoverImage(artworkFile)
            setFieldValue("thumbnailImg", compressed)
          } catch (e) {
            setFieldValue("thumbnailImg", artworkFile)
          }
          console.log('[UploadMusic] Auto-populated album artwork');
        }

        notifier.success('Metadata extracted from file!');
      }
    } catch (error) {
      console.error('[UploadMusic] Failed to extract metadata:', error);
      // Fallback to filename for title
      const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
      setFieldValue("title", fileNameWithoutExt);
    }
  };

  React.useEffect(() => {
    disableDates("releaseDate");
  });
  let year = new Date().getFullYear() - userData["birthYear"];

  {/*-------------------------------------------------------------------------------------------*/}

  return (
    <Box className="__upload_music_container">
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography className="web_header fs-20">
          {t("sidebar.button.button1")}
        </Typography>
        {uploadLimits && (
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: "6px",
                backgroundColor: uploadLimits.tier === "pro" ? "rgba(255, 238, 32, 0.15)" : "rgba(255,255,255,0.06)",
                border: `1px solid ${uploadLimits.tier === "pro" ? "rgba(255, 238, 32, 0.3)" : "rgba(255,255,255,0.1)"}`,
              }}
            >
              <Typography sx={{ color: uploadLimits.tier === "pro" ? "#FFEE20" : "#888", fontSize: 12, fontWeight: 600, textTransform: "uppercase" }}>
                {uploadLimits.tier === "free" ? "Free" : uploadLimits.tier === "basic" ? "Basic" : "Pro"}
              </Typography>
            </Box>
            <Typography sx={{ color: uploadLimits.remaining === 0 ? "#f44336" : "#888", fontSize: 13 }}>
              {uploadLimits.remaining === -1
                ? "Unlimited uploads"
                : `${uploadLimits.remaining} of ${uploadLimits.limit} uploads remaining`}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Box className="__upload_box" sx={{ display: 'flex', justifyContent: 'center' }}>
        <Stack className="__upload_steps" spacing={2} sx={{ display: 'none' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="row" gap="10px" alignItems="center">
              <Upload
                width="20px"
                height="20px"
                className="__input_icon"
                set="bulk"
                primaryColor="white"
              />
              <Stack direction="column">
                <Typography className="fs-14 faded">{t("step")} 1</Typography>
                <Typography className="fs-16">
                  {t("uploadMusic.step1")}
                </Typography>
              </Stack>
            </Stack>
            <DoneIcon
              sx={{
                backgroundColor: "#2CF488",
                borderRadius: "50%",
                fontSize: "14px !important",
                padding: "2px",
                color: "#1E1E1E",
              }}
            />
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="row" gap="10px" alignItems="center">
              <InfoIcon
                sx={{
                  color: "#999999",
                  fontSize: "20px !important",
                  borderRadius: "50%",

                  padding: "2px",
                }}
              />
              <Stack direction="column">
                <Typography className="fs-14 faded">{t("step")} 2</Typography>
                <Typography className="fs-16">
                  {t("uploadMusic.step2")}
                </Typography>
              </Stack>
            </Stack>
            {step > 1 ? (
              <DoneIcon
                sx={{
                  backgroundColor: "#2CF488",
                  borderRadius: "50%",
                  fontSize: "14px !important",
                  padding: "2px",
                  color: "#1E1E1E",
                }}
              />
            ) : null}
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="row" gap="10px" alignItems="center">
              <GroupsIcon
                sx={{
                  color: "#999999",
                  fontSize: "21px !important",
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
              <Stack direction="column">
                <Typography className="fs-14 faded">{t("step")} 3</Typography>
                <Typography className="fs-16">
                  {t("uploadMusic.step3")}
                </Typography>
              </Stack>
            </Stack>
            {step >= 3 ? (
              <DoneIcon
                sx={{
                  backgroundColor: "#2CF488",
                  borderRadius: "50%",
                  fontSize: "14px !important",
                  padding: "2px",
                  color: "#1E1E1E",
                }}
              />
            ) : null}
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="row" gap="10px" alignItems="center">
              <AttachMoneyIcon
                sx={{
                  color: "#999999",
                  fontSize: "21px !important",
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
              <Stack direction="column">
                <Typography className="fs-14 faded">{t("step")} 4</Typography>
                <Typography className="fs-16">
                  {t("uploadMusic.step4")}
                </Typography>
              </Stack>
            </Stack>
            {step === 4 ? (
              <DoneIcon
                sx={{
                  backgroundColor: "#2CF488",
                  borderRadius: "50%",
                  fontSize: "14px !important",
                  padding: "2px",
                  color: "#1E1E1E",
                }}
              />
            ) : null}
          </Stack>
        </Stack>
        <Box className="__upload_music" sx={{ minWidth: "500px" }}>
          <Box className="__main_pading" sx={{ paddingBottom: "50px", minWidth: "400px" }}>
            <Formik
              validationSchema={schema}
              onSubmit={(values, errors) => {
                uploadMusic(values);
              }}
              initialValues={{
                ownerRoyalty: "",
                artist: "",
                title: "",
                description: "",
                genre: "",
                subGenre: "",
                audioFile: "",
                thumbnailImg: "",
                GIF: "",
                ISRCCode: "",
                isExplicit: year < 18 ? false : "",
                isAIGenerated: false,
                subscribersOnly: false,
                lyrics: "",
                releaseDate: "",
                rightsConfirmed: false,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                setFieldValue,
              }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <Stack spacing={3} className="__upload_form" >
                    {/* Two-column layout */}
                    <Stack direction="row" spacing={4} alignItems="flex-start">
                      {/* LEFT COLUMN - Cover, Title, Audio */}
                      <Stack spacing={2.5} sx={{ width: '240px', flexShrink: 0 }}>
                        {/* Cover Image */}
                        <FormControl>
                          <Typography className={"__label"} variant="body1" sx={{ mb: 1 }}>
                            {t("uploadMusic.input2.label")}
                          </Typography>

                          <Box
                            onClick={() => onFileChooser("thumbnailImg")}
                            sx={{
                              width: '240px',
                              height: '240px',
                              position: 'relative',
                              borderRadius: '12px',
                              border: values.thumbnailImg ? "none" : validationErrors.thumbnailImg ? "2px dashed rgba(255, 107, 107, 0.5)" : "2px dashed #4d4d4d",
                              backgroundColor: '#171515',
                              cursor: 'pointer',
                              overflow: 'hidden',
                              '&:hover': {
                                borderColor: values.thumbnailImg ? 'none' : '#F48706',
                              },
                            }}
                          >
                            <Box sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}>
                              {values.thumbnailImg ? (
                                <img
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  src={URL.createObjectURL(values.thumbnailImg)}
                                  alt="Cover"
                                />
                              ) : (
                                <Stack alignItems="center" spacing={1}>
                                  <img src={Images.upload} style={{ width: '32px', height: '32px' }} alt="" />
                                  <Typography sx={{ fontSize: "12px", color: '#666' }}>
                                    Click to upload
                                  </Typography>
                                </Stack>
                              )}
                            </Box>
                          </Box>

                          <input
                            type="file"
                            style={{ display: "none" }}
                            accept="image/*"
                            //accept="png,jpg,jpeg,gif,image/png,image/gif,image/jpg,image/jpeg,application/octet-stream"
                            id="thumbnailImg"
                            onChange={async (e) => {
                              await handleThumbnailChangeExternal(e, setFieldValue);
                              if (validationErrors.thumbnailImg) {
                                setValidationErrors({...validationErrors, thumbnailImg: false});
                              }
                            }}
                            required
                          />
                        </FormControl>

                        {/* Title */}
                        <FormControl>
                          <Typography className={"__label"} variant="body1">
                            {t("uploadMusic.input4.label")}
                          </Typography>
                          <Box className="__upload_inputbox" sx={getErrorStyle(validationErrors.title)}>
                            <OutlinedInput
                              value={values.title}
                              onChange={(e) => {
                                e.preventDefault();
                                const { value } = e.target;
                                const regex = /^[a-zA-Z0-9 !@#$%\^&*)(+=._-]*$/;
                                if (regex.test(value.toString())) {
                                  setFieldValue("title", value);
                                  if (validationErrors.title) {
                                    setValidationErrors({...validationErrors, title: false});
                                  }
                                }
                              }}
                              className="__input"
                              name="title"
                              placeholder={t("uploadMusic.input4.placeholder")}
                            />
                          </Box>
                        </FormControl>

                        {/* Audio File */}
                        <FormControl>
                          <Typography className={"__label"} variant="body1">
                            {t("uploadMusic.input1.lable")}
                          </Typography>
                          <Box
                            className="__upload_inputbox"
                            onClick={() => onFileChooser("audioFile")}
                            sx={getErrorStyle(validationErrors.audioFile)}
                          >
                            <Box className="__input">
                              {values.audioFile ? values.audioFile.name : t("uploadMusic.input1.placeholder")}
                            </Box>
                            <Upload className="__input_icon" set="bulk" primaryColor="white" />
                          </Box>
                          <input
                            type="file"
                            accept=".mp3,audio/*"
                            style={{ display: "none" }}
                            id="audioFile"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setFieldValue("audioFile", file);
                                if (validationErrors.audioFile) {
                                  setValidationErrors({...validationErrors, audioFile: false});
                                }
                                await extractMetadataAndPopulate(file, setFieldValue);
                              }
                            }}
                            required
                          />
                        </FormControl>
                      </Stack>

                      {/* RIGHT COLUMN - All other fields */}
                      <Stack spacing={2.5} sx={{ flex: 1 }}>
                        {/* Artist */}
                        <FormControl>
                          <Stack direction="column">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              className="mt-20"
                              alignItems="baseline"
                            >
                              <Stack direction="column">
                                <Typography variant="body1" color="default">
                                  {t("uploadMusic.input3.label")}
                                </Typography>
                              </Stack>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                                onClick={(e) => {
                                  handleAddArtists("add", null);
                                  e.preventDefault();
                                }}
                              >
                                <Typography variant="body2" color="default">
                                  {t("uploadMusic.input10.button")}
                                </Typography>
                                <Plus
                                  className="__input_icon _cp"
                                  set="light"
                                  primaryColor="white"
                                />
                              </Stack>
                            </Stack>
                            {artist.map((c, index) => (
                              <Stack direction="column" key={index}>
                                {index > 0 ? (
                                  <Stack
                                    direction="row"
                                    mt={1}
                                    justifyContent="flex-end"
                                  >
                                    <IndeterminateCheckBoxOutlinedIcon
                                      className="__input_icon"
                                      color="default"
                                      onClick={() =>
                                        handleAddArtists("remove", index)
                                      }
                                    />
                                  </Stack>
                                ) : null}
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="end"
                                >
                                  <Box sx={{
                                    width: "50%",
                                    ...(index === 0 ? getErrorStyle(validationErrors.artistRole) : {})
                                  }}>
                                    <DropDown
                                      title={
                                        roless.length > 0 &&
                                        roless[index]["title"]
                                          ? roless[index]["title"]
                                          : t("select")
                                      }
                                      onChange={({ key, value }) => {
                                        roless[index]["role"] = value;
                                        handleArtistRoleChange(
                                          key,
                                          value,
                                          null,
                                          index
                                        );
                                        if (index === 0 && validationErrors.artistRole) {
                                          setValidationErrors({...validationErrors, artistRole: false});
                                        }
                                      }}
                                      values={[
                                        {
                                          key: "mainArtist",
                                          // value: "mainArtist",
                                          value: t("dropDown.text9"),
                                        },
                                        {
                                          key: "featuredArtist",
                                          value: t("dropDown.text10"),
                                        },
                                      ]}
                                    />
                                  </Box>
                                  <SikiInput
                                    top="0"
                                    isSearch={true}
                                    isArtist={true}
                                    placeholder={t(
                                      "uploadMusic.input10.placeholder"
                                    )}
                                    width={"50%"}
                                    error={index === 0 && validationErrors.artist}
                                    // value={values.artist}
                                    // value={typeof c === "object" ? c.artist : c}
                                    value={
                                      c == " "
                                        ? ""
                                        : typeof c === "object"
                                        ? c?.name
                                        : c
                                    }
                                    // onInvite={(e) =>{
                                    //   setSelectedArtist(
                                    //     `${e["firstName"]} ${e["lastName"]}`,
                                    //     e._id,
                                    //     index
                                    //   )}
                                    // }
                                    onChange={(
                                      e,
                                      uId,
                                      profileImg,
                                      firstName,
                                      fullName,
                                      lastName,
                                      displayArtistName
                                    ) => {
                                      setSelectedArtist(
                                        e,
                                        uId,
                                        profileImg,
                                        firstName,
                                        fullName,
                                        lastName,
                                        displayArtistName,
                                        index
                                      );
                                      setFieldValue("artist", e, uId, index);
                                      if (index === 0 && validationErrors.artist) {
                                        setValidationErrors({...validationErrors, artist: false});
                                      }
                                    }}
                                  />
                                </Stack>
                              </Stack>
                            ))}
                          </Stack>
                        </FormControl>

                        {/* Description */}
                        <FormControl
                          className="__form_control"
                          sx={{ width: "100%" }}
                        >
                          <Stack direction="row" justifyContent="space-between">
                            <Typography className={"__label"} variant="body1">
                              {t("uploadMusic.input5.label")}
                            </Typography>
                            <Typography className={"__info"} variant="body1">
                              {t("uploadMusic.input5.hint")}
                            </Typography>
                          </Stack>

                          <Box className="__upload_inputbox" sx={getErrorStyle(validationErrors.description)}>
                            <OutlinedInput
                              inputProps={{ maxLength: 180 }}
                              value={values.description}
                              onChange={(e) => {
                                handleChange(e);
                                if (validationErrors.description) {
                                  setValidationErrors({...validationErrors, description: false});
                                }
                              }}
                              className="__input"
                              name="description"
                              placeholder={t("uploadMusic.input5.placeholder")}
                            />
                          </Box>
                        </FormControl>

                        {/* Genre */}
                        <Box>
                          <Typography className={"__label"} variant="body1">
                            {t("uploadMusic.input6.label")}
                          </Typography>
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            gap="7px"
                            mt="7px"
                            sx={{ width: "100%" }}
                          >
                            <Box sx={{
                              width: "50%",
                              ...getErrorStyle(validationErrors.genre)
                            }}>
                              <DropDown
                                onChange={(b) => {
                                  setFieldValue("genre", b);
                                  if (validationErrors.genre) {
                                    setValidationErrors({...validationErrors, genre: false});
                                  }
                                }}
                                title={
                                  values.genre
                                    ? values.genre
                                    : t("uploadMusic.input6.placeholder1")
                                }
                                values={genres}
                              />
                            </Box>
                            <Box sx={{
                              width: "50%",
                              ...getErrorStyle(validationErrors.subGenre)
                            }}>
                              <DropDown
                                title={
                                  values.subGenre
                                    ? values.subGenre
                                    : t("uploadMusic.input6.placeholder2")
                                }
                                onChange={(b) => {
                                  setFieldValue("subGenre", b);
                                  if (validationErrors.subGenre) {
                                    setValidationErrors({...validationErrors, subGenre: false});
                                  }
                                }}
                                values={genres}
                              />
                            </Box>
                          </Stack>
                        </Box>

                        {/* Explicit */}
                        <Stack direction="column">
                          <Typography variant="body1" color="default">
                            {t("uploadMusic.input7.label")}
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{
                              marginTop: "10px",
                              ...getErrorStyle(validationErrors.isExplicit),
                            }}
                          >
                            <Button
                              onClick={() => {
                                setFieldValue("isExplicit", true);
                                if (validationErrors.isExplicit) {
                                  setValidationErrors({...validationErrors, isExplicit: false});
                                }
                              }}
                              color="primary"
                              variant="contained"
                              sx={{
                                backgroundColor: "#171515",
                                width: "50%",
                                justifyContent: "flex-start",
                                color:
                                  values.isExplicit === ""
                                    ? "#FFFFFF50"
                                    : "#ffffff",
                              }}
                              startIcon={
                                values.isExplicit === true ? (
                                  <DoneIcon
                                    sx={{
                                      backgroundColor: "#FFEE20",
                                      borderRadius: "50%",
                                      fontSize: "14px !important",
                                      padding: "2px",
                                      color: "#000000",
                                    }}
                                  />
                                ) : null
                              }
                              disabled={year < 18}
                            >
                              {t("uploadMusic.input7.placeholder1")}
                            </Button>
                            <Button
                              onClick={() => {
                                setFieldValue("isExplicit", false);
                                if (validationErrors.isExplicit) {
                                  setValidationErrors({...validationErrors, isExplicit: false});
                                }
                              }}
                              color="primary"
                              variant="contained"
                              sx={{
                                backgroundColor: "#171515",
                                width: "50%",
                                justifyContent: "flex-start",
                                color:
                                  values.isExplicit === ""
                                    ? "#FFFFFF50"
                                    : "#ffffff",
                              }}
                              startIcon={
                                values.isExplicit === false ? (
                                  <DoneIcon
                                    sx={{
                                      backgroundColor: "#FFEE20",
                                      borderRadius: "50%",
                                      fontSize: "14px !important",
                                      padding: "2px",
                                      color: "#000000",
                                    }}
                                  />
                                ) : null
                              }
                            >
                              {t("uploadMusic.input7.placeholder2")}
                            </Button>
                          </Stack>
                        </Stack>

                        {/* Subscribers only */}
                        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 3 }}>
                          <Stack direction="column">
                            <Typography variant="body1" color="default">Subscribers only</Typography>
                            <Typography variant="caption" sx={{ opacity: 0.6 }}>Only your subscribers can stream it in full.</Typography>
                          </Stack>
                          <IosSwitch
                            checked={!!values.subscribersOnly}
                            onChange={(e) => setFieldValue("subscribersOnly", e.target.checked)}
                          />
                        </Stack>

                        {/* AI Generated */}
                        <Stack direction="column" sx={{ mt: 3 }}>
                          <Typography variant="body1" color="default">
                            Is this song AI generated?
                          </Typography>
                          <Stack direction="row" spacing={2} sx={{ marginTop: "10px" }}>
                            <Button
                              onClick={() => setFieldValue("isAIGenerated", true)}
                              color="primary"
                              variant="contained"
                              sx={{
                                backgroundColor: "#171515",
                                width: "50%",
                                justifyContent: "flex-start",
                                color: "#ffffff",
                              }}
                              startIcon={
                                values.isAIGenerated === true ? (
                                  <DoneIcon
                                    sx={{
                                      backgroundColor: "#FFEE20",
                                      borderRadius: "50%",
                                      fontSize: "14px !important",
                                      padding: "2px",
                                      color: "#000000",
                                    }}
                                  />
                                ) : null
                              }
                            >
                              Yes
                            </Button>
                            <Button
                              onClick={() => setFieldValue("isAIGenerated", false)}
                              color="primary"
                              variant="contained"
                              sx={{
                                backgroundColor: "#171515",
                                width: "50%",
                                justifyContent: "flex-start",
                                color: "#ffffff",
                              }}
                              startIcon={
                                values.isAIGenerated === false ? (
                                  <DoneIcon
                                    sx={{
                                      backgroundColor: "#FFEE20",
                                      borderRadius: "50%",
                                      fontSize: "14px !important",
                                      padding: "2px",
                                      color: "#000000",
                                    }}
                                  />
                                ) : null
                              }
                            >
                              No
                            </Button>
                          </Stack>
                        </Stack>

                        {/* Release Date */}
                        <FormControl
                          className="__form_control _cp"
                          style={{ width: "100%" }}
                        >
                          <Typography className={"__label"} variant="body1">
                            {t("uploadMusic.input8.label")}
                          </Typography>

                          <Box className="__upload_inputbox" sx={getErrorStyle(validationErrors.releaseDate)}>
                            <input
                              id="releaseDate"
                              style={{ border: 0, width: "100%" }}
                              type="date"
                              className="__input date-click"
                              value={values.releaseDate}
                              placeholder={t("uploadMusic.input8.label")}
                              onChange={(e) => {
                                setFieldValue("releaseDate", e.target.value);
                                if (validationErrors.releaseDate) {
                                  setValidationErrors({...validationErrors, releaseDate: false});
                                }
                              }}
                            />

                            <Calendar
                              className="__input_icon"
                              set="light"
                              primaryColor="white"
                            />
                          </Box>
                        </FormControl>
                      </Stack>
                    </Stack>

                    <Box>
                        <Stack direction="column">
                          <Typography
                            variant="body1"
                            color="default"
                            className="fw-b"
                            sx={{ mb: 1 }}
                          >
                            Song Split Royalties
                          </Typography>
                          <Typography className="fs-14 mb-10" color="default">
                            Add the owners of the record with their percentage of song owned
                          </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            onClick={addMoreRoyalties}
                            className="_cp"
                          >
                            <Typography
                              variant="body2"
                              color="default"
                              sx={{ marginRight: "8px !important" }}
                              className="_cp"
                            >
                              {t("uploadMusic.input11.button")}
                            </Typography>
                            <Plus
                              className="__input_icon"
                              set="light"
                              primaryColor="white"
                            />
                          </Stack>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "21px",
                          }}
                        >
                          <Stack>
                            {royalties.map((r, index) => (
                              <Stack key={index}>
                                <Stack
                                  direction="row"
                                  mt={1}
                                  justifyContent="space-between"
                                >
                                  <Typography className="fs-14 mt-5">
                                    {t("uploadMusic.input12.label3")}{" "}
                                    {index + 1}
                                  </Typography>
                                  {index > 0 ? (
                                    <IndeterminateCheckBoxOutlinedIcon
                                      className="__input_icon _cp"
                                      color="default"
                                      onClick={() =>
                                        handleRemoveRoyalties(index)
                                      }
                                    />
                                  ) : null}
                                </Stack>

                                <Box>
                                  <SikiInput
                                    top="0"
                                    isSearch={true}
                                    isRoyalty={true}
                                    placeholder={t(
                                      "editProfile.input6.placeholder"
                                    )}
                                    // value={royalty[index]}
                                    value={
                                      r == " "
                                        ? ""
                                        : royalty && royalty[index]
                                        ? royalty[index]
                                        : typeof r === "object"
                                        ? r["name"]
                                        : r
                                    }
                                    songTitle={values.title}
                                    artistName={artist[0]?.displayArtistName || userData?.displayArtistName || `${userData?.firstName || ''} ${userData?.lastName || ''}`.trim()}
                                    percentage={royalties[index]?.percentage}
                                    onInvite={(e, id) => {
                                      const tempName = royalty;
                                      tempName[index] = e;
                                      const temp = royalties;
                                      if (id) temp[index]["_id"] = id;
                                      else if (temp[index]["_id"])
                                        delete temp[index]["_id"];
                                      setRoyalty(tempName);
                                      setRoyalties([...temp]);
                                    }}
                                    onChange={(e, id) => {
                                      const tempName = royalty;
                                      tempName[index] = e;
                                      const temp = royalties;
                                      if (id) temp[index]["_id"] = id;
                                      else if (temp[index]["_id"])
                                        delete temp[index]["_id"];
                                      setRoyalty(tempName);
                                      setRoyalties([...temp]);
                                    }}
                                  />

                                  <SikiInput
                                    top="0"
                                    isSearch={false}
                                    value={royalties[index]["percentage"]}
                                    onChange={(e) => {
                                      const temp = royalties;
                                      if (parseInt(e) >= 0)
                                        temp[index]["percentage"] = parseInt(e);
                                      else if (temp[index]["percentage"])
                                        delete temp[index]["percentage"];

                                      setRoyalties([...temp]);
                                      // sumRoyalties();
                                    }}
                                    placeholder={t(
                                      "uploadMusic.input12.placeholder2"
                                    )}
                                    type="number"
                                  />
                                </Box>
                              </Stack>
                            ))}
                          </Stack>
                        </Box>
                        </Stack>
                      </Box>

                    {/* Advanced Section: ISRC and Contributors */}
                    {showAdvanced && (
                      <Box sx={{ mb: 4 }}>
                        <FormControl
                          className="__form_control"
                          sx={{ width: "100%" }}
                        >
                          <Typography className={"__label"} variant="body1">
                            {t("uploadMusic.input9.label")}
                          </Typography>
                          <Box className="__upload_inputbox">
                            <OutlinedInput
                              value={values.ISRCCode}
                              onChange={handleChange}
                              className="__input"
                              name="ISRCCode"
                              placeholder={t("uploadMusic.input9.placeholder")}
                            />
                          </Box>
                        </FormControl>
                        <FormControl className="__form_control" sx={{ width: "100%", mt: 2 }}>
                          <Typography className={"__label"} variant="body1">
                            Lyrics <span style={{ opacity: 0.5, fontSize: 12 }}>(optional, shown on the song page)</span>
                          </Typography>
                          <Box className="__upload_inputbox">
                            <OutlinedInput
                              value={values.lyrics}
                              onChange={handleChange}
                              className="__input"
                              name="lyrics"
                              multiline
                              minRows={4}
                              placeholder="Paste or type the lyrics"
                            />
                          </Box>
                        </FormControl>
                        <Stack direction="column">
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            className="mt-20"
                            alignItems="baseline"
                          >
                            <Stack direction="column">
                              <Typography variant="body1" color="default">
                                {t("uploadMusic.input10.label1")}
                              </Typography>
                              <Typography className="fs-14" color="default">
                                {t("uploadMusic.input10.label2")}
                              </Typography>
                            </Stack>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                              onClick={() => handleAddContributers("add", null)}
                            >
                              <Typography variant="body2" color="default">
                                {t("uploadMusic.input10.button")}
                              </Typography>
                              <Plus
                                className="__input_icon"
                                set="light"
                                primaryColor="white"
                              />
                            </Stack>
                          </Stack>
                          {contributers.map((c, index) => (
                            <Stack direction="column" key={index}>
                              {index > 0 ? (
                                <Stack
                                  direction="row"
                                  mt={1}
                                  justifyContent="flex-end"
                                >
                                  <IndeterminateCheckBoxOutlinedIcon
                                    className="__input_icon"
                                    color="default"
                                    onClick={() =>
                                      handleAddContributers("remove", index)
                                    }
                                  />
                                </Stack>
                              ) : null}
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="end"
                              >
                                <Box sx={{ width: "50%" }}>
                                  <DropDown
                                    title={
                                      roles.length > 0 && roles[index]["role"]
                                        ? roles[index]["role"]
                                        : t("select")
                                    }
                                    onChange={({ value }) => {
                                      roles[index]["role"] = value;
                                      handleRoleChange(value, null, index);
                                    }}
                                    values={[
                                      {
                                        key: "text4",
                                        value: t("dropDown.text4"),
                                      },
                                      {
                                        key: "text5",
                                        value: t("dropDown.text5"),
                                      },
                                      {
                                        key: "text6",
                                        value: t("dropDown.text6"),
                                      },
                                      {
                                        key: "text7",
                                        value: t("dropDown.text7"),
                                      },
                                      {
                                        key: "text8",
                                        value: t("dropDown.text8"),
                                      },
                                    ]}
                                  />
                                </Box>
                                <SikiInput
                                  top="0"
                                  isSearch={true}
                                  placeholder={t(
                                    "uploadMusic.input10.placeholder"
                                  )}
                                  width={"50%"}
                                  value={
                                    c == " "
                                      ? ""
                                      : typeof c === "object"
                                      ? c["name"]
                                      : c
                                  }
                                  onInvite={(e) =>
                                    setSelectedContributers(
                                      `${e["firstName"]} ${e["lastName"]}`,
                                      e._id,
                                      index
                                    )
                                  }
                                  onChange={(e, id) =>
                                    setSelectedContributers(e, id, index)
                                  }
                                />
                              </Stack>
                            </Stack>
                          ))}
                        </Stack>
                      </Box>
                    )}

                    {/* Rights Confirmation */}
                    <Stack direction="row" alignItems="flex-start" sx={{ mt: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.rightsConfirmed}
                            onChange={(e) => setFieldValue("rightsConfirmed", e.target.checked)}
                            sx={{ color: '#FFEE20', '&.Mui-checked': { color: '#FFEE20' } }}
                          />
                        }
                        label={
                          <Typography sx={{ fontSize: '13px', color: '#aaa' }}>
                            By uploading, I confirm that I own or have the necessary rights and licenses to distribute this content. I accept full responsibility for any copyright claims related to this upload.
                          </Typography>
                        }
                      />
                    </Stack>

                    {/* Buttons Row: Upload Music and Advanced */}
                    <Stack
                      direction="row"
                      sx={{ marginTop: "40px !important" }}
                      justifyContent="center"
                      alignItems="center"
                      spacing={2}
                    >
                      <Button
                        sx={{
                          height: 56,
                          minWidth: "240px",
                          fontSize: "16px",
                          fontWeight: 600,
                          backgroundColor: '#000000',
                          color: '#FFEE20',
                          border: '2px solid #FFEE20',
                          '&:hover': {
                            backgroundColor: '#1a1a1a',
                            borderColor: '#FFEE20',
                          },
                          '&:disabled': {
                            backgroundColor: '#000',
                            color: '#666',
                            borderColor: '#666',
                          }
                        }}
                        variant="outlined"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Processing..." : t("uploadMusic.button3")}
                      </Button>

                      <Button
                        variant="outlined"
                        onClick={() => setShowAdvanced(!showAdvanced)}
                        sx={{
                          height: 56,
                          minWidth: "160px",
                          fontSize: "16px",
                          fontWeight: 600,
                          borderColor: '#F48706',
                          color: '#F48706',
                          '&:hover': {
                            borderColor: '#F48706',
                            backgroundColor: 'rgba(244, 135, 6, 0.1)',
                          },
                        }}
                      >
                        {showAdvanced ? 'Hide Advanced' : 'Advanced'}
                      </Button>
                    </Stack>
                  </Stack>
                </form>
              )}
            </Formik>
          </Box>
        </Box>
      </Box>

      {loading ? (
        <Box className="__loader">
          <Stack
            direction="column"
            alignItems="center"
            spacing={2}
            sx={{
              padding: "30px",
              borderRadius: "6px",
              background: "#171515",
              minWidth: "400px",
            }}
          >
            <Loader wait={true} message={uploadStatus || "Uploading..."} />
            {uploadProgress > 0 && (
              <Box sx={{ width: '100%', mt: 2 }}>
                <LinearProgress 
                  variant="determinate" 
                  value={uploadProgress} 
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: '#333',
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: '#FFEE20',
                      borderRadius: 4,
                    }
                  }}
                />
                <Typography 
                  variant="body2" 
                  sx={{ mt: 1, textAlign: 'center', color: '#999' }}
                >
                  {uploadProgress}%
                </Typography>
              </Box>
            )}
          </Stack>
        </Box>
      ) : null}
      {success ? (
        <SuccessPopup
          open={success}
          handleClose={() => setSuccess(false)}
          duration={3000}
          message={t("success.message9")}
        />
      ) : null}
      {error ? (
        <ErrorPopup
          open={error}
          error={Errors}
          handleClose={() => setError(false)}
        />
      ) : null}
      {/* NFT popup removed - no upfront cost anymore */}
    </Box>
  );
}
